import { PersistedStorageKeys } from "constants/persisted-storage-keys";

/**
 * Reset the persisted storage.
 */
export const resetStorage = () => {
    Object.entries(PersistedStorageKeys).forEach(([_key, value]) => {
        localStorage.removeItem(value);
    });
};
